// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { login } from '../../redux/reducers/authentication';

import LoginForm from '../../components/Login/LoginForm';

class Login extends Component {
    onLogin: Function;

    constructor(props) {
        super(props);

        this.onLogin = this.onLogin.bind(this);
    }

    onLogin(formValues) {
        const { email, password } = formValues;
        return this.props.dispatch(login(email, password));
    }

    render() {
        const { loginError } = this.props;

        return <LoginForm loginError={loginError} onSubmit={this.onLogin} />;
    }
}

const mapStateToProps = state => {
    return {
        loginError: state.authentication.error,
    };
};

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/Login.js